<div class="flex gap-2 overflow-hidden">
  <lib-avatars class="inline-flex" [persons]="[participant]" [size]="32"></lib-avatars>
  @if (participant.firstName && participant.lastName) {
    <div class="flex items-center gap-1 overflow-hidden">
      <span class="typo-h4-medium text-text-primary">{{ participant.firstName }} {{ participant.lastName }}</span>
      <span class="typo-h4-thin truncate">
        @if (participant.participantRole === EmployeeType.PROVIDER || participant.participantRole === EmployeeType.STAFF) {
          ({{ participant.email || participant.pmsEmployeeId }})
        } @else if (participant.participantRole === 'patient') {
          (Dentrix Patient ID {{ participant.pmsPatientId }})
        }
      </span>
    </div>
  } @else {
    <div class="flex items-center overflow-hidden">
      <span class="typo-h4-light truncate text-text-primary">{{
        participant.email || participant.pmsPatientId || participant.pmsEmployeeId
      }}</span>
    </div>
  }
</div>

@if (isValidStatus() || !participant.irremovable) {
  <div class="inline-flex items-center gap-3">
    @if (isValidStatus()) {
      <div class="typo-h4-thin text-primary-blue">
        @if (participant.status === EmployeeStatus.NOT_INVITED || participant.status === PatientStatus.NOT_INVITED) {
          {{ 'collab_new_collab_modal_collaboration_to_be_invited' | translate }}
        } @else if (participant.status === EmployeeStatus.PENDING || participant.status === PatientStatus.PENDING) {
          {{ 'collab_new_collab_modal_collaboration_invite_pending' | translate }}
        }
      </div>
    }

    @if (!participant.irremovable) {
      <button
        type="button"
        class="inline-flex"
        (click)="onRemoveParticipant()"
        [libUiTooltip]="removeButtonTooltip"
        [tooltipPosition]="'top'"
      >
        <svg-icon class="text-text-tertiary" key="px-16-x" size="sm"></svg-icon>
      </button>
      <ng-template #removeButtonTooltip>
        <div class="typo-h5-book p-2 text-text-secondary">
          {{ 'collab_new_collab_modal_collaboration_remove_participant_label' | translate }}
        </div>
      </ng-template>
    }
  </div>
}
